import { render } from "./servises.vue?vue&type=template&id=221bc919"
import script from "./servises.vue?vue&type=script&lang=js"
export * from "./servises.vue?vue&type=script&lang=js"

import "./servises.vue?vue&type=style&index=0&id=221bc919&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__